import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Spinner } from "components/common";
import { Button } from "components/bootstrap";
import { useMetrics } from "hooks/useMetrics";
import {
  getMetricNamesForInput,
  calculateInputMetrics,
  getInputConnectionMetrics,
  formatCount
} from "components/inputs/helpers/InputThroughputUtils";
import { NetworkIOStats, Connections, NodesMetricsDetails } from "components/inputs/InputsOveriew";
const ThroughputSection = ({ input }) => {
  const { t } = useTranslation("inputs");
  const metricNames = getMetricNamesForInput(input);
  const { data: metrics, isLoading } = useMetrics(metricNames);
  const [showDetails, setShowDetails] = useState(false);
  const toggleShowDetails = () => {
    setShowDetails(!showDetails);
  };
  if (isLoading || Object.keys(metrics).length === 0) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const calculatedMetrics = calculateInputMetrics(input, metrics);
  const {
    openConnections,
    totalConnections,
    emptyMessages,
    writtenBytes1Sec,
    writtenBytesTotal,
    readBytes1Sec,
    readBytesTotal
  } = getInputConnectionMetrics(input, calculatedMetrics);
  return /* @__PURE__ */ React.createElement("span", null, isNaN(writtenBytes1Sec) && isNaN(openConnections) && /* @__PURE__ */ React.createElement("i", null, t("overview.sections.no_input_metrics")), !isNaN(writtenBytes1Sec) && /* @__PURE__ */ React.createElement(
    NetworkIOStats,
    {
      readBytes1Sec,
      writtenBytes1Sec,
      readBytesTotal,
      writtenBytesTotal
    }
  ), /* @__PURE__ */ React.createElement("br", null), !isNaN(openConnections) && !isNaN(totalConnections) && /* @__PURE__ */ React.createElement(Connections, { openConnections, totalConnections }), !isNaN(emptyMessages) && /* @__PURE__ */ React.createElement("span", null, t("overview.sections.empty_messages_discarded", { value: formatCount(emptyMessages) }), /* @__PURE__ */ React.createElement("br", null)), !isNaN(writtenBytes1Sec) && input.global && /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: toggleShowDetails }, showDetails ? t("overview.sections.hide_details") : t("overview.sections.show_details")), /* @__PURE__ */ React.createElement("br", null), !isNaN(writtenBytes1Sec) && showDetails && /* @__PURE__ */ React.createElement(NodesMetricsDetails, { input, metrics }));
};
export default ThroughputSection;
